<template>
    <div class="m-thirdStep">
        <!-- 待审核 1-->
        <!-- <merchantInfo v-if="showInfo"/> -->
        <merchant-info :is-register="true" v-if="thisStep > 3.3 || thisStep == 3.1 "/>
        <!-- 审核通过 10-->
        <div class="audit audit-pass" v-if="thisStep == 3.2">
            <i class="el-icon-success icon"></i>
            <div class="tips">恭喜！您的服务商审核已经通过！</div>
        </div>
        <!-- 审核不通过 2-->
        <div class="audit audit-return" v-else-if="thisStep == 3.3">
            <i class="el-icon-error icon"></i>
            <template v-if="checkRemark">
                <p class="tips">您的审核未通过，原因如下：</p>
                <p class="reason red-font">{{ checkRemark }}</p>
            </template>
        </div>
        
    </div>
</template>

<script>
import * as access from "@/config/access";
import merchantInfo from '@/views/setting/merchant/merchantInfo';
import API from '@/fetch/api';
//ystRegisterStep  云商通认证步骤:0(未认证)1(已注册并提交公司信息)2(已认证公司信息，待签电子协议)3(已完成电子协议签约，待处理其他认证)10(已完成服务商注册)
// :0(未提交审核)1(待审核)2(审核驳回)10(审核通过)mI

export default {
    props: {
        thisStep: {
            type: Number,
            default: 0
        },
        checkRemark: {
            type: String,
            default: ''
        }
    },
    data(){
        let checkStatus = access.session('checkStatus') || '',
            steps = access.session('ystRegisterStep') || '';
        return {
            checkStatus,
            steps,
        }
    },
    computed: {
        showInfo(){
            return this.checkStatus == 1 || this.steps == 2 || this.steps == 3;
        }
    },
    components: {
        merchantInfo
    },
    mounted(){
        if(this.steps == 2) this.toSign();
    },
    methods: {
        toSign(){
            let vm = this;
            this.$confirm('已认证公司信息，待签电子协议。是否前往？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                confirmButtonClass: 'btnNew btnSize',
                cancelButtonClass: 'btnSize',
            }).then(() => {
                API.http({url: '/merchant/yst_sign', type: 'get'}).then(res => {
                    if(res.code == 200){window.location.href
                        window.location.href = res.data;
                        return;
                    }
                    vm.$showAlert(res.message || '获取签约地址失败，请重试', 'error')
                }).catch(res => {
                    vm.$showAlert('获取签约地址失败，请重试', 'error')
                })
            })
        }
    }
}
</script>

<style lang="scss" >
@import '../style/variable';
    .m-thirdStep{
        .audit{
            padding-top: 30px;
            text-align: center;
            &.audit-pass{
                .tips,.el-icon-success{
                    color: $c4;
                }
            }
            &.audit-return{
                .reason, .el-icon-error{
                    color: $c20;
                }
            }
            .icon{
                font-size: 50px;
            }
            .tips{
                padding: 20px;
                font-size: 20px;
            }
        }
    }
</style>